import(/* webpackMode: "eager", webpackExports: ["Image"] */ "/app/frontend-next/src/app/_ui/components/core/Image.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LinkTracked"] */ "/app/frontend-next/src/app/_ui/components/core/LinkTracked.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next-intl@4.8.3_@swc+helpers@0.5.19_next@16.2.2_@babel+core@7.29.0_@opentelemetry+api@1_622da044ce9ee44dbbbc2340f85851cf/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
